import { createStaticVNode, defineComponent, openBlock, createElementBlock } from 'vue';

const _hoisted_1 = {
  width: "32px",
  height: "32px",
  viewBox: "0 0 32 32",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
};
const _hoisted_2 = /* @__PURE__ */ createStaticVNode('<title>icon_header_login</title><g id="p1-\u898F\u7BC4\u8207\u5207\u5716" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.3"><g id="p1-header/footer/mobile\u641C\u5C0B\u4EA4\u4E92" transform="translate(-1784.000000, -574.000000)"><g id="header" transform="translate(0.000000, 284.000000)"><g id="web/header/1920\u5907\u4EFD" transform="translate(0.000000, 274.000000)"><g id="icon_header_login" transform="translate(1784.000000, 16.000000)"><rect id="bg" x="0" y="0" width="32" height="32"></rect><path id="\u5F62\u72B6\u7ED3\u5408" d="M16,0 C24.836556,0 32,7.163444 32,16 C32,24.836556 24.836556,32 16,32 C7.163444,32 0,24.836556 0,16 C0,7.163444 7.163444,0 16,0 Z M21.2477183,19.3478236 L21.0997233,19.4842688 C19.7222785,20.7238737 17.9428872,21.4709111 16,21.4709111 C13.9871117,21.4709111 12.1497129,20.6690733 10.7522817,19.3478236 C7.87119973,20.4499952 5.58932701,22.4316134 4.41973042,24.8733091 C7.0862611,28.3480876 11.2815233,30.5882353 16,30.5882353 C20.7189277,30.5882353 24.9145409,28.3476593 27.5814582,24.8715994 C26.4100484,22.431071 24.128406,20.4498444 21.2477183,19.3478236 Z M16,6.26970269 C12.5635616,6.26970269 9.77777778,9.29363848 9.77777778,13.0238523 C9.77777778,16.7540662 12.5635616,19.778002 16,19.778002 C19.4364384,19.778002 22.2222222,16.7540662 22.2222222,13.0238523 C22.2222222,9.29363848 19.4364384,6.26970269 16,6.26970269 Z" fill="#818D95"></path></g></g></g></g></g>', 2);
const _hoisted_4 = [
  _hoisted_2
];
const __default__ = defineComponent({
  name: "TvbUserIcon"
});
var _sfc_main = /* @__PURE__ */ defineComponent({
  ...__default__,
  setup(__props) {
    ;
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=User.vue2.mjs.map
